import React from "react";
import styled from "styled-components";

export const SiteFooterWrapper = styled.section`
  text-align: center;
  color: #fff;
  margin: 20px 0 120px 0;
  a {
    color: #fff;
  }
`;

const SiteFooter = (props) => (
  <SiteFooterWrapper>
    Copyright &copy; {new Date().getFullYear()}{" "}
    <a href="//www.dreamchimney.com/" target="_top">
      Dream Chimney
    </a>{" "}
    Inc.
  </SiteFooterWrapper>
);

export default SiteFooter;
